/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description Code field component
 */
import _ from 'lodash';
import { Input } from '@formily/antd-v5';

import Button from 'components/widgets/button';
import { EMPTY_VALUE } from '@veritable/common/constants';

export interface IProps {
	value?: string;
	codeDetails?: CodeExplorer.ICodeSummaryResponse;
	fieldType?: 'input' | 'text';
	isEditable?: boolean;
	isDisabled?: boolean;
	onChange?: (value: string) => void;
}

const CodeField: React.FC<IProps> = ({
	value,
	codeDetails,
	fieldType = 'input',
	isEditable = false,
	isDisabled = false,
	onChange,
	...props
}) => {
	const codeDetailsItem = _.find(codeDetails?.result, (item) => item.code === value);

	if (isEditable) {
		return <Input {...props} value={value} disabled={isDisabled} onChange={(e) => onChange?.(e.target.value)} />;
	}

	if (fieldType === 'text') {
		return codeDetailsItem && value ? <Button.ShowClaimCode codeDetails={codeDetailsItem} /> : (value ?? EMPTY_VALUE);
	}

	return (
		<div
			style={{
				border: '1px solid #f0f0f0',
				borderRadius: '6px',
				padding: '4px 11px',
				background: '#fff',
				color: '#8c8c8c',
				height: '32px',
				display: 'flex',
				alignItems: 'center',
				cursor: 'text',
			}}
		>
			{value && (codeDetailsItem ? <Button.ShowClaimCode codeDetails={codeDetailsItem} /> : value)}
		</div>
	);
};

export default CodeField;
